import React from 'react'

const Sunglass = () => {
  return (
    <div>Sunglass</div>
  )
}

export default Sunglass